export default "__VITE_ASSET__CEODy$zA__"